import { useEffect, useRef } from "react";
import CountUp from "react-countup";
import { Link } from "react-router-dom";

export default function BalanceDisplay({ balance }) {
  const prevBalanceRef = useRef(balance);

  useEffect(() => {
    prevBalanceRef.current = balance;
  }, [balance]);

  return (
    <div className="text-center my-10">
      <Link
        to="/budget"
        className="text-5xl sm:text-6xl font-semibold font-poppins 
                   bg-gradient-to-r from-green-500 via-green-400 to-green-300 
                   text-transparent bg-clip-text 
                   transform hover:scale-105 transition-transform duration-300 inline-block
                   leading-tight"
      >
        <CountUp
          start={prevBalanceRef.current}
          end={balance}
          duration={1.8}
          decimals={2}
          prefix="$"
        />
      </Link>

      <p className="text-center mt-2 text-base sm:text-lg md:text-xl 
                    bg-gradient-to-r from-blue-300 to-green-300 bg-clip-text 
                    text-transparent font-[Poppins]">
        Current Balance
      </p>
    </div>
  );
}
